import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {
  DEFAULT_DEALER_REPORT_RANGE,
  formatPercent,
  trackDealerPerformanceEvent,
} from "../../../constants/automapDealerPerformanceConstants";
import { useDealerPortalIntl } from "../../../hooks/useDealerPortalIntl";
import { fetchDealerLeadSourceSummary } from "../../../services/automapDealerPerformanceApi";
import { DealerReportsNav, ReportPageHeader } from "./DealerPerformanceShared";

export default function DealerSourceReportPage() {
  const { dealerId } = useOutletContext();
  const { t, translateError } = useDealerPortalIntl();
  const [range, setRange] = useState(DEFAULT_DEALER_REPORT_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    trackDealerPerformanceEvent("dealer_source_report_viewed", { dealerId, range });
  }, [dealerId, range]);

  useEffect(() => {
    setLoading(true);
    fetchDealerLeadSourceSummary(dealerId, range)
      .then(setPayload)
      .catch((err) => setError(translateError(err.message, "loadReports")))
      .finally(() => setLoading(false));
  }, [dealerId, range]);

  return (
    <div className="dealer-reports">
      <DealerReportsNav active="fuentes" />
      <ReportPageHeader
        title={t("reports.sourcesReport")}
        description={t("reports.sourcesReportDesc")}
        dealerId={dealerId}
        range={range}
        onRangeChange={setRange}
      />
      {loading ? <p className="dealer-state-box">{t("reports.loading")}</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error ? (
        <>
          <section className="dealer-state-box">
            <h3>Contribución por canal</h3>
            <div className="dashboard-lead-stats">
              <span>SEO: {payload.seoContribution ?? 0}</span>
              <span>Quiz: {payload.quizContribution ?? 0}</span>
              <span>Recomendaciones: {payload.recommendationContribution ?? 0}</span>
              <span>Guías: {payload.guideContribution ?? 0}</span>
              <span>Checklist: {payload.checklistContribution ?? 0}</span>
              {payload.topCampaign ? (
                <span>
                  Top campaña: {payload.topCampaign.key} ({payload.topCampaign.count})
                </span>
              ) : null}
            </div>
          </section>
          <section className="dealer-state-box">
            <h3>Resumen por fuente</h3>
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Fuente</th>
                  <th>Leads</th>
                  <th>Calificados</th>
                  <th>Conversión</th>
                </tr>
              </thead>
              <tbody>
                {(payload.sources || []).map((row) => (
                  <tr key={row.source}>
                    <td>{row.source}</td>
                    <td>{row.leadCount}</td>
                    <td>{row.qualifiedLeadCount}</td>
                    <td>{formatPercent(row.conversionRate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        </>
      ) : null}
    </div>
  );
}
